import { render, staticRenderFns } from "./c-horizontal-scrollbar.vue?vue&type=template&id=67a206e1&"
import script from "./c-horizontal-scrollbar.vue?vue&type=script&lang=js&"
export * from "./c-horizontal-scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./c-horizontal-scrollbar.vue?vue&type=style&index=0&id=67a206e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports